import { Navigate, Outlet } from "react-router-dom";
import { useSessionAuth } from "@/app/_utils/sessionClient";
import FullPageLoader from "@/app/admin/_common/FullPageLoader";

/**
 * Route guard for a page permission. Sits inside RequireAuth, so by the time it runs
 * there is a session; it only decides whether this user may see this route.
 */
export default function RequirePermission({
  permission,
}: {
  permission: string;
}) {
  const { can, status, session } = useSessionAuth();

  if (status === "loading" && !session) {
    return <FullPageLoader />;
  }
  if (!can(permission)) {
    return <Navigate to="/admin/no-access" replace />;
  }
  return <Outlet />;
}
